import * as React from 'react';

// Markdown styles for assistant message bodies. These used to live inside
// AssistantWidget, which no longer exists — the assistant is now a
// conversation inside the chat panel, so whatever hosts AssistantChat has to
// render this once.
export const AssistantStyles: React.FC = () => (
  <style>{`
    .didi-markdown p { margin: 0 0 8px; }
    .didi-markdown p:last-child { margin-bottom: 0; }
    .didi-markdown ol, .didi-markdown ul { margin: 4px 0 8px; padding-left: 20px; }
    .didi-markdown li { margin-bottom: 2px; }
    .didi-markdown strong { font-weight: 600; }
    .didi-markdown code { background: #edf2f7; padding: 1px 4px; border-radius: 3px; font-size: 12px; }
    .didi-markdown pre { background: #edf2f7; padding: 8px; border-radius: 6px; overflow-x: auto; margin: 4px 0 8px; }
    .didi-markdown pre code { background: none; padding: 0; }
    .didi-markdown h1, .didi-markdown h2, .didi-markdown h3 { margin: 8px 0 4px; font-size: 14px; font-weight: 600; }
    .didi-markdown blockquote { border-left: 3px solid #cbd5e0; margin: 4px 0 8px; padding-left: 10px; color: #718096; }
    .didi-markdown a { color: #2C5282; text-decoration: underline; font-weight: 500; }
    .didi-markdown a:hover { color: #1a365d; }

    /* Claude answers "show me my applicants" with a markdown table, and the
       chat panel is ~320px wide. Unstyled, the header wrapped mid-word
       ("Applica / nts") and the columns collided. Let it scroll instead of
       squeezing, and keep the numeric column intact. */
    .didi-markdown table {
      display: block;
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      margin: 4px 0 10px;
      font-size: 12.5px;
    }
    .didi-markdown thead th {
      text-align: left;
      font-weight: 700;
      color: #16233b;
      border-bottom: 1px solid #cbd5e0;
      padding: 4px 10px 4px 0;
      white-space: nowrap;
    }
    .didi-markdown tbody td {
      padding: 4px 10px 4px 0;
      border-bottom: 1px solid #edf2f7;
      vertical-align: top;
      line-height: 1.35;
    }
    /* Counts read as a column, not as text wrapped against the title. */
    .didi-markdown thead th:not(:first-child),
    .didi-markdown tbody td:not(:first-child) {
      text-align: right;
      white-space: nowrap;
      padding-right: 0;
    }
    .didi-markdown tbody tr:last-child td { border-bottom: 0; }
  `}</style>
);

export default AssistantStyles;
